import clsx from 'clsx'
import React from 'react'

import { CONTENT_CONTAINER_STYLES } from 'src/libs/design-system'

import { FeaturesComparisonTable } from './features-comparison-table'
import { PricingPlanCards } from './pricing-plan-cards'
import { FeatureBundle, Plan } from './types'

interface PricingSectionProps<PlanKey extends string> {
    plans: [Plan<PlanKey>, Plan<PlanKey>, Plan<PlanKey>]
    featureBundles: FeatureBundle<PlanKey>[]
}

export function PricingSection<PlanKey extends string>(props: PricingSectionProps<PlanKey>) {
    const { plans } = props
    return (
        <div className={clsx(CONTENT_CONTAINER_STYLES, 'grid gap-24')}>
            <PricingPlanCards plans={plans} />
            <FeaturesComparisonTable {...props} />
        </div>
    )
}
